import queryString from "query-string";
import { BaseParams } from "types";
import { RtkTagTypes } from "types/enums";
import { apiService } from "../apiService";

const BASE_ROUTE = "/organizationPortal";

export interface OrganizationPortalSubmissionParams extends BaseParams {
  status?: string;
}

export interface OrganizationPortalSubmissionDto {
  id: number;
  submissionNumber?: string;
  submittedAtUtc?: string;
  status?: string;
  formDataJson?: string;
  linkedEventId?: number;
  linkedEventNumber?: string;
  organizationPortalSubmissionTopicId?: number;
  organizationPortalSubmissionTopicCode?: string;
}

export interface OrganizationPortalTopicOption {
  id: number;
  code?: string;
  description?: string;
}

export interface OrganizationPortalDto {
  id?: number;
  organizationId?: number;
  slug?: string;
  name?: string;
  isEnabled?: boolean;
  themeJson?: string;
  formDefinitionJson?: string;
  allowAttachments?: boolean;
  topicOptions?: OrganizationPortalTopicOption[];
}

const organizationPortalEndpoint = apiService.injectEndpoints({
  endpoints: (builder: any) => ({
    getOrganizationPortalSubmissions: builder.query({
      query: (params: OrganizationPortalSubmissionParams) =>
        `${BASE_ROUTE}/submissions?${queryString.stringify(params)}`,
      providesTags: [RtkTagTypes.GetPortalSubmissions],
      transformResponse: (response: any, meta: any) => {
        const paginationHeader = meta?.response?.headers?.get("Pagination");
        let pagination: { totalItems?: number } = {};
        if (paginationHeader) {
          try {
            pagination = JSON.parse(paginationHeader) as {
              totalItems?: number;
            };
          } catch {
            // ignore
          }
        }
        return { data: response, pagination };
      },
    }),
    getOrganizationPortalSubmissionById: builder.query({
      query: (id: number) => `${BASE_ROUTE}/submissions/${id}`,
      providesTags: (_: any, __: any, id: number) => [
        { type: RtkTagTypes.GetPortalSubmissions, id },
      ],
    }),
    getDescriptionForEventFromSubmission: builder.query({
      query: (id: number) =>
        `${BASE_ROUTE}/submissions/${id}/descriptionForEvent`,
    }),
    updateOrganizationPortalSubmissionStatus: builder.mutation({
      query: ({
        id,
        status,
        topicId,
      }: {
        id: number;
        status: string;
        topicId?: number | null;
      }) => ({
        url: `${BASE_ROUTE}/submissions/${id}/status`,
        method: "PATCH",
        body: { status, topicId },
      }),
      invalidatesTags: [RtkTagTypes.GetPortalSubmissions],
    }),
    getPortalSubmissionCountByFilterId: builder.query({
      query: (filterId: number) =>
        `${BASE_ROUTE}/submissions/count/${filterId}`,
    }),
  }),
});

export const {
  useGetOrganizationPortalSubmissionsQuery,
  useLazyGetOrganizationPortalSubmissionByIdQuery,
  useLazyGetDescriptionForEventFromSubmissionQuery,
  useUpdateOrganizationPortalSubmissionStatusMutation,
  useLazyGetPortalSubmissionCountByFilterIdQuery,
} = organizationPortalEndpoint;
